import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { sessionProvider } from 'utils';
import { fetchAccount } from 'store/actions/account';

export default () => {
  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(sessionProvider.isAuthenticated());
  const { data, loading } = useSelector((state) => state.account);

  useEffect(() => {
    dispatch(fetchAccount());
  }, []);

  useEffect(() => {
    const handleStorageUpdate = () => {
      setIsAuthenticated(sessionProvider.isAuthenticated());
    };
    handleStorageUpdate();
    window.addEventListener('storage', handleStorageUpdate);
    return () => {
      window.removeEventListener('storage', handleStorageUpdate);
    };
  }, [data]);

  return {
    isAuthenticated: isAuthenticated && sessionProvider.isAuthenticated(),
    user: data?.attributes ?? {},
    id: data?.id,
    patientId: data?.attributes?.patientId,
    loading,
  };
};
